import React, { ReactElement, useContext, useState } from 'react'
import { Context } from '@/components/Context'
import Button from '@/components/Button'
import { PersonalWallet } from '@/database/personalwallet'

const TransferNft = ({ wallet }: { wallet: PersonalWallet }): ReactElement => {
    const { accountSignature, proxyTransferNft } = useContext(Context)
    const [address, setAddress] = useState('')
    const [tokenId, setTokenId] = useState('')
    const [recipient, setRecipient] = useState('')

    const transactionHandler = async (event: { preventDefault: () => void }) => {
        event.preventDefault()
        const parsedTokenId = parseInt(tokenId, 10)
        if (!address || !tokenId || !recipient || parsedTokenId < 1) {
            window.alert('Please fill all the fields')
            return
        }
        if (!accountSignature) {
            window.alert('Please connect your wallet to proceed transaction')
            return
        }
        if (!wallet) {
            window.alert('Wallet not found')
            return
        }
        await proxyTransferNft(wallet.address, address, parsedTokenId, recipient)
    }

    const handleAddressInputChange = (event: { target: { value: string } }) => {
        setAddress(event.target.value)
    }

    const handleReceiverInputChange = (event: { target: { value: string } }) => {
        setRecipient(event.target.value)
    }

    const handleTokenIdInputChange = (event: { target: { value: string } }) => {
        setTokenId(event.target.value)
    }

    return (
        <div className="form ">
            <div className="artwork-box padding-five">
                <form onSubmit={transactionHandler} className={'bottom2'}>
                    <div>NFT Address</div>
                    <div className={'flex-row form-as-class align-right'}>
                        <input
                            className="width335"
                            placeholder={`... Contract Address ...`}
                            value={address}
                            onChange={handleAddressInputChange}
                        />
                    </div>
                    <div>NFT ID</div>
                    <div className={'flex-row form-as-class align-right'}>
                        <input
                            className="width335"
                            type="number"
                            min={1}
                            placeholder={`... NFT # ...`}
                            value={tokenId}
                            onChange={handleTokenIdInputChange}
                        />
                    </div>
                    <div>Receiver</div>
                    <div className={'flex-row form-as-class align-right'}>
                        <input
                            className="width335"
                            placeholder="... Receiver Address ..."
                            value={recipient}
                            onChange={handleReceiverInputChange}
                        />
                    </div>
                    <Button
                        btnName={`Send`}
                        classStyles={'nav__medium center bottom'}
                        disabled={!accountSignature || !wallet || !address || !tokenId || !recipient}
                        handleClick={(event: { preventDefault: () => void }) =>
                            accountSignature
                                ? transactionHandler(event)
                                : alert('Please connect your wallet to proceed transaction')
                        }
                        cancelBg={undefined}
                    />
                </form>
            </div>
        </div>
    )
}
export default TransferNft
